import { MainContainer, MenuAppBar, Wrapper } from '../../components';
import { Typography } from '@mui/material/';
import { NotfoundWrapper } from './404.styles';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';
import URLs from '../URLs';
import { useTranslation } from 'react-i18next';

export const Error404Page = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Wrapper>
      <MenuAppBar />
      <MainContainer>
        <NotfoundWrapper>
          <Typography variant={'h1'} color={'primary'}>
            404
          </Typography>
          <Typography variant={'h6'} color={'primary'}>
            {t('404.pageNotFound')}
          </Typography>
          <Button variant="contained" onClick={() => navigate(URLs.ROOT)}>
            {t('404.goHome')}
          </Button>
        </NotfoundWrapper>
      </MainContainer>
    </Wrapper>
  );
};
